import React from 'react'
import { Typography, Box } from '@mui/material'

import { useTheme } from '@mui/material/styles'

const sx = {
  iconWrapper: {
    width: 28,
    color: '#25245F',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '15px',
  },
  linkSignUp: {
    cursor: 'pointer',
    fontSize: '14px',
  },
}

const BusinessStatsRisks = props => {
  const theme = useTheme()
  const { riskScore, riskClass } = props


  let colors =
    riskClass >= 4
      ? theme.palette.color.negative
      : riskClass <= 2
        ? theme.palette.color.aqua110
        : theme.palette.color.blueLight

  return (
    <Box sx={sx.wrapper}>
      <div>
        <Box sx={sx.row}>
          <Typography variant="body2">
            Business Credit Risk Score<sup>TM</sup>:&nbsp;
          </Typography>
          {riskScore !== null ? (
            <>
              <span className="font14px">
                <Typography
                  component="span"
                  variant="h6"
                  sx={{
                    color: theme.palette.color.blueLight,
                  }}
                >
                  {riskScore}
                </Typography>
              </span>
            </>
          ) : (
            <>
              <Typography
                component="span"
                variant="h6"
                sx={{
                  color: theme.palette.color.darkBlue30,
                }}
              >
                NA
              </Typography>
            </>
          )}
        </Box>
        <Box sx={sx.row}>
          <Typography variant="body2">
            Business Credit Risk Class<sup>TM</sup>:&nbsp;
          </Typography>
          {riskClass !== null ? (
            <>
              <Typography
                component="span"
                variant="h6"
                sx={{
                  color: colors,
                }}
              >
                {riskClass}
              </Typography>
            </>
          ) : (
            <>
              <Typography
                component="span"
                variant="h6"
                sx={{
                  color: theme.palette.color.darkBlue30,
                }}
              >
                NA
              </Typography>
            </>
          )}
        </Box>
      </div>
    </Box>
  )
}

export default BusinessStatsRisks
